import {
  ChangeDetectionStrategy,
  Component,
  input,
  output
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';

import { FileThumbnailComponent } from '@file-upload/components/file-thumbnail/file-thumbnail.component';
import { Attachment } from '@file-upload/models/attachment';

// ! This is used for style-guide page

@Component({
  selector: 'app-files-list',
  templateUrl: './files-list.component.html',
  styleUrls: ['./files-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatIcon, FileThumbnailComponent]
})
export class FilesListComponent {
  readonly files = input.required<Attachment[]>();

  readonly deleteFile = output<Attachment>();

  onDeleteFile(file: Attachment): void {
    this.deleteFile.emit(file);
  }
}
